/** @format */
import ceremony from '../../../assets/ceremony.png';
import dining from '../../../assets/dining.png';

export const imageArray = [
	'https://a0.muscache.com/im/pictures/96d9f9a5-cced-4bef-ae7c-13d3293028d3.jpg',
	'https://a0.muscache.com/im/pictures/0b54b841-b59e-4491-b3bd-a3f483b7d4c8.jpg',
	'https://a0.muscache.com/im/pictures/346ba5e7-db3e-4c50-80aa-28c9822ae572.jpg',
	'https://a0.muscache.com/im/pictures/3c44fb64-078c-4f56-9e51-4a6d4f2680df.jpg',
	'https://a0.muscache.com/im/pictures/c9aec1f7-b559-40e8-b65e-c466783fab82.jpg',
	'https://a0.muscache.com/im/pictures/2eb21432-fbe8-4e86-9b71-e9ae5f672415.jpg',
	'https://a0.muscache.com/im/pictures/8913a9f9-2d16-4b2b-a72c-e3629cf862c4.jpg',
	'https://a0.muscache.com/im/pictures/e898ac8b-4c0f-4ff0-ba9d-48f44650fd7f.jpg',
	'https://a0.muscache.com/im/pictures/344652fe-f169-4b84-93c3-1de9b089993c.jpg',
	'https://a0.muscache.com/im/pictures/fb3818d3-1c2b-4a7f-9960-fe02b79cbda8.jpg',
	ceremony,
	dining,
];
export const airBnbLinks = [
	{
		href: 'https://www.airbnb.com/s/Bailey--CO/homes?adults=2&refinement_paths%5B%5D=%2Fhomes&tab_id=home_tab&flexible_trip_dates%5B%5D=november&flexible_trip_dates%5B%5D=october&flexible_trip_lengths%5B%5D=weekend_trip&date_picker_type=calendar&ne_lat=39.506147143646864&ne_lng=-105.38012221385952&sw_lat=39.340923016158364&sw_lng=-105.57374015380856&zoom=12&search_by_map=true&search_type=user_map_move&query=Bailey%2C%20CO',
		name: 'bailey',
	},
	{
		href: 'https://www.airbnb.com/s/Denver--Colorado--United-States/homes?adults=2&refinement_paths%5B%5D=%2Fhomes&tab_id=home_tab&flexible_trip_dates%5B%5D=november&flexible_trip_dates%5B%5D=october&flexible_trip_lengths%5B%5D=weekend_trip&date_picker_type=calendar&search_type=autocomplete_click&query=Denver%2C%20Colorado%2C%20United%20States&place_id=ChIJzxcfI6qAa4cR1jaKJ_j0jhE&checkin=2023-07-21&checkout=2023-07-23&source=structured_search_input_header',
		name: 'denver',
	},
	{
		href: 'https://www.airbnb.com/s/Conifer--Colorado--United-States/homes?adults=2&refinement_paths%5B%5D=%2Fhomes&tab_id=home_tab&flexible_trip_dates%5B%5D=november&flexible_trip_dates%5B%5D=october&flexible_trip_lengths%5B%5D=weekend_trip&date_picker_type=calendar&search_type=autocomplete_click&query=Conifer%2C%20Colorado%2C%20United%20States&place_id=ChIJA7bcoFFxa4cRzyG8MMfi3iM&source=structured_search_input_header',
		name: 'conifer',
	},
	{
		href: 'https://www.airbnb.com/s/Lakewood--CO--United-States/homes?flexible_trip_dates%5B%5D=november&flexible_trip_dates%5B%5D=october&flexible_trip_lengths%5B%5D=weekend_trip&date_picker_type=calendar&refinement_paths%5B%5D=%2Fhomes&tab_id=home_tab&source=structured_search_input_header&search_type=autocomplete_click&query=Lakewood%2C%20CO%2C%20United%20States&place_id=ChIJt3LdXG-Ba4cRl87Q8fpdkJ4',
		name: 'lakewood',
	},
];
